import { useGetCategoriesQuery, CategoryState } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { categoriesColumns, type CategoryRow, type CategoryFilterInput } from '../constants/categoriesColumns';

const defaultFilters: Partial<CategoryFilterInput> = {
    state: [CategoryState.Regular, CategoryState.Created],
};

export const CategoriesList = () => {
    const { loading: categoriesLoading, data: categoriesData, error: categoriesError } = useGetCategoriesQuery();

    if (categoriesLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!categoriesData || categoriesError) {
        throw new Error('Une erreur est survenue lors de la récupération des catégories');
    }

    const { categories } = categoriesData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<CategoryRow, CategoryFilterInput>
                columns={categoriesColumns}
                data={categories}
                defaultFilters={defaultFilters}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/category/${row._id}`}
                searchPlaceholder="Nom de la catégorie"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
